export const skillResults = [
  { code: 1, name: 'Not Started' },
  { code: 2, name: 'Keep Learning' },
  { code: 3, name: 'Almost There' },
  { code: 4, name: 'Passed' },
  { code: 5, name: 'Placed Out' },
  { code: 6, name: 'Review' },
];

export const skillType = [
  { code: 'Unit', name: 'Unit' },
  { code: 'Support', name: 'Support' },
  { code: 'Additional Support', name: 'Additional Support' },
  { code: 'Extension', name: 'Extension' },
];

export const sortedBy = [
  { value: 'readinessScore', label: 'Most ready for' },
  { value: 'name', label: 'Alphabetical' },
];

export enum sortedByLabel {
  READINESS_SCORE = 'readinessScore',
  NAME = 'name',
}
